import vt1stScience from "./vt1stScienceQuizContent";
import vt1stSocialStudies from "./vt1stSocialStudiesQuizContent";
import vt1stMath from "./vt1stMathQuizContent";
import vt1stOther from "./vt1stOtherQuizContent";

// 2nd Grade
import vt2ndScience from "./vt2ndScienceQuizContent";
import vt2ndSocialStudies from "./vt2ndSocialStudiesQuizContent";
import vt2ndMath from "./vt2ndMathQuizContent";
import vt2ndOther from "./vt2ndOtherQuizContent";

// 3rd Grade
import vt3rdScience from "./vt3rdScienceQuizContent";
import vt3rdSocialStudies from "./vt3rdSocialStudiesQuizContent";
import vt3rdMath from "./vt3rdMathQuizContent";
import vt3rdOther from "./vt3rdOtherQuizContent";

// 4th Grade
import vt4thScience from "./vt4thScienceQuizContent";
import vt4thSocialStudies from "./vt4thSocialStudiesQuizContent";
import vt4thMath from "./vt4thMathQuizContent";
import vt4thOther from "./vt4thOtherQuizContent";

// 5th Grade
import vt5thScience from "./vt5thScienceQuizContent";
import vt5thSocialStudies from "./vt5thSocialStudiesQuizContent";
import vt5thMath from "./vt5thMathQuizContent";
import vt5thOther from "./vt5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const vttopicsMapBySubject = {
  // 1st Grade
  vt_1st_science: vt1stScience,
  vt_1st_socialstudies: vt1stSocialStudies,
  vt_1st_math: vt1stMath,
  vt_1st_other: vt1stOther,

  // 2nd Grade
  vt_2nd_science: vt2ndScience,
  vt_2nd_socialstudies: vt2ndSocialStudies,
  vt_2nd_math: vt2ndMath,
  vt_2nd_other: vt2ndOther,

  // 3rd Grade
  vt_3rd_science: vt3rdScience,
  vt_3rd_socialstudies: vt3rdSocialStudies,
  vt_3rd_math: vt3rdMath,
  vt_3rd_other: vt3rdOther,

  // 4th Grade
  vt_4th_science: vt4thScience,
  vt_4th_socialstudies: vt4thSocialStudies,
  vt_4th_math: vt4thMath,
  vt_4th_other: vt4thOther,

  // 5th Grade
  vt_5th_science: vt5thScience,
  vt_5th_socialstudies: vt5thSocialStudies,
  vt_5th_math: vt5thMath,
  vt_5th_other: vt5thOther,
  // ...add the rest
};
